import { unlockVideoPlayers } from './video-player.js';

const KEY = 'cookie_consent';

export function initCookieConsent() {
   if (localStorage.getItem(KEY)) return;

   const banner = document.getElementById('cookie-consent');
   if (!banner) return;

   banner.classList.add('is-visible');

   banner.querySelector('.cookie-consent__accept').addEventListener('click', () => {
      localStorage.setItem(KEY, 'accepted');
      banner.classList.remove('is-visible');
      unlockVideoPlayers();
   });

   banner.querySelector('.cookie-consent__decline').addEventListener('click', () => {
      localStorage.setItem(KEY, 'declined');
      banner.classList.remove('is-visible');
   });
}
